import {
  Box,
  Card,
  CardDescription,
  ClipboardLabel,
  ClipboardRoot,
  FormatNumber,
  Heading,
  HStack,
  Image,
  Spinner,
} from "@chakra-ui/react";
import { ComponentProps } from "react";

import { GoonAvatar } from "./goon-avatar";
import { ClipboardIconButton } from "./ui/clipboard";

import { useAuth } from "@/hooks/useAuth";
import { useSeasonOneStats } from "@/hooks/useSeasonOneStats";
import { truncateAddress } from "@/utils";
import collectedPlumeMilesSvg from "/assets/season/collected-plume-miles.svg";
import collectedStampsSvg from "/assets/season/collected-stamps.svg";
import referredUsersSvg from "/assets/season/referred-users.svg";

const STANDARD_PADDING = 6;

export const SeasonStatsCard = ({
  showProfile,
  ...props
}: { showProfile: boolean } & ComponentProps<typeof Card.Root>) => {
  const { address } = useAuth();
  const { miles, stamps, referrals, isLoading } = useSeasonOneStats();
  if (isLoading) return <Spinner />;
  if (!address) return null;
  return (
    <Card.Root flex={1} rounded="24px" {...props}>
      {showProfile && (
        <HStack
          p={STANDARD_PADDING}
          gap={STANDARD_PADDING}
          borderBottomWidth={1}
        >
          <GoonAvatar seed={address} boxSize={12} />
          <Box>
            <ClipboardRoot
              value={address}
              display="flex"
              alignItems="center"
              gap={2}
            >
              <ClipboardLabel mb={0}>
                <Heading size="lg">{truncateAddress(address)}</Heading>
              </ClipboardLabel>
              <ClipboardIconButton />
            </ClipboardRoot>
          </Box>
        </HStack>
      )}
      <HStack borderBottomWidth={1} p={STANDARD_PADDING} gap={STANDARD_PADDING}>
        <Image src={collectedPlumeMilesSvg} />
        <Box>
          <Heading size="lg">Collected Plume Miles</Heading>
          <CardDescription fontSize="md">
            <FormatNumber value={miles} />
          </CardDescription>
        </Box>
      </HStack>
      <HStack borderBottomWidth={1} p={STANDARD_PADDING} gap={STANDARD_PADDING}>
        <Image src={collectedStampsSvg} />
        <Box>
          <Heading size="lg">Collected Stamps</Heading>
          <CardDescription fontSize="md">
            <FormatNumber value={stamps} />
          </CardDescription>
        </Box>
      </HStack>
      <HStack p={STANDARD_PADDING} gap={STANDARD_PADDING}>
        <Image src={referredUsersSvg} />
        <Box>
          <Heading size="lg">Referred Users</Heading>
          <CardDescription fontSize="md">
            <FormatNumber value={referrals} />
          </CardDescription>
        </Box>
      </HStack>
    </Card.Root>
  );
};
